import {Injectable} from '@angular/core';

/*
  Generated class for the AudioServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AudioServiceProvider {
  constructor() {
  }

  public PlaySuccess() {
    let proxy = window["PlaySoundCheckInSucceeded"];
    if (proxy !== undefined) {
      proxy.postMessage("");
    }
  }

  public PlayFailure() {
    let proxy = window["PlaySoundCheckInFailed"];
    if (proxy !== undefined) {
      proxy.postMessage("");
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/audio-service/audio-service.ts